import { CheckboxItemTheme, getCheckboxItem } from './CheckboxListItem/theme';
import { getInternalListItem, InternalListItemTheme } from './InternalListItem/theme';
import { getMultipleActionsListItem, MultipleActionsListItem } from './MultipleActionsListItem/theme';
import { getRadioItem, RadioItemTheme } from './RadioListItem/theme';
import { getSortableItem, SortableItemTheme } from './SortableListItem/theme';

export const getListItems = () => {
  return {
    internalItem: getInternalListItem() as InternalListItemTheme,
    sortableListItem: getSortableItem() as SortableItemTheme,
    radioListItem: getRadioItem() as RadioItemTheme,
    checkboxListItem: getCheckboxItem() as CheckboxItemTheme,
    multipleActionsListItem: getMultipleActionsListItem() as MultipleActionsListItem,
  };
};

export type ListItemsTheme = ReturnType<typeof getListItems>;
